import * as Yup from "yup";
import { getPatchOperations } from "../../../util/form";
import { FmulinjeKursist } from "../../../interfaces/schema";
import InputItem from "../../../components/formcontrols/InputItem";

export const editLinjeKursistForm = (
  fmulinjeId: string,
  kursist: FmulinjeKursist,
): FormConfig<EditFmulinjeKursistDTO> => {
  const get = `fmulinje/${fmulinjeId}/kursister/${kursist.id}`;
  const patchQuery = `fmulinje/${fmulinjeId}/kursister/${kursist.id}`;
  return {
    title: "kursist",
    get,
    form: [
      {
        component: "custom",
        label: "Navn",
        id: "navn",
        customComponent: () => (
          <InputItem
            id="navn"
            label="Navn"
            setValue={() => {}}
            disabled={true}
            value={`${kursist.person.fornavne} ${kursist.person.efternavn}`}
          />
        ),
      },
      {
        component: "kode-select",
        id: "overnatning",
        initialValue: kursist.overnatning ?? "",
        label: "Overnatning",
        isRequired: true,
        kodeListeType: "OvernatningstypeKode",
        placeholder: "Vælg overnatningstype",
      },
    ],
    validationSchema: Yup.object({
      overnatning: Yup.string().required("Overnatningstype skal være valgt"),
    }),
    patch: (body) => {
      return {
        query: patchQuery,
        body: getPatchOperations(body),
      };
    },
  };
};

interface EditFmulinjeKursistDTO {
  // afmeldingsGebyr: number;
  overnatning: string;
}
